import * as nouveauPackageFormNames from "./nouveauPackageFormNames";

export const nouveauPackageInitialValues = {
  [nouveauPackageFormNames.ROLE_OPERATEUR_FORM_NAME]: "",
  [nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME]: "",
  [nouveauPackageFormNames.EXERCICE_FORM_NAME]: "",
  [nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME]: "",
  [nouveauPackageFormNames.TYPE_PAIEMENT_FORM_NAME]: "",
  [nouveauPackageFormNames.TRANSACTION_AUTORISEE_FORM_NAME]: "",
  [nouveauPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME]: "",
  [nouveauPackageFormNames.FRAIS_ACCES_ANNUEL_FORM_NAME]: "",
  [nouveauPackageFormNames.DEBUT_VALIDITEE_PACKAGE_FORM_NAME]: "",
  [nouveauPackageFormNames.STATUS_PACKAGE_FORM_NAME]: "",
  [nouveauPackageFormNames.TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME]: "",
  [nouveauPackageFormNames.RECONDUCTION_PACKAGE_FORM_NAME]: "",
  [nouveauPackageFormNames.FRAIS_TRANSACTION_FORM_NAME]: "",
  [nouveauPackageFormNames.DESCRIPTION_FORM_NAME]: "",
};
